import React, { useEffect, useState } from 'react';
import { ChatAI } from 'dx-chat-ai-client';
import { getConfigFromAPI } from './dynamic-config';

export function WidgetChatAI({ userId, lang, deviceType }) {
  if (!userId || typeof window === typeof undefined) {
    return null;
  }

  const [config, setConfig] = useState(null);
  const fixed = deviceType === 'mobile' ? { bottom: 20, right: 20 } : { bottom: 30, right: 40 };

  useEffect(() => {
    if (!config) {
      getConfigFromAPI({
        dialogWindow: true,
        portal: document.body,
        fixed,
        lang,
      })
        .then(setConfig)
        .catch(console.error);
    }
  }, []);

  if (!config) {
    return null;
  }

  return (
    <ChatAI {...config} />
  );
}
